import React from 'react';

import IconWithText from 'components/Widgets/IconWithText';

export default function FinishGeneral() {
  return (
    <>
      <h1>Congratulations on Your First Step!</h1>
      <p className="mt-3">
        You&apos;ve taken the first important step in your leadership development journey.
      </p>

      <IconWithText
        iconClassName="big-icon onboarding-cpa-download-icon-1 bg-secondary"
        wrapperClassName="mb-3 mt-5"
      >
        <h6>Review your Talent Assessment to understand your unique leadership style and potential growth areas.</h6>
      </IconWithText>

      <IconWithText
        iconClassName="big-icon onboarding-cpa-download-icon-2 bg-secondary"
        wrapperClassName="mb-3"
      >
        <h6>Feel free to discuss the results with your manager or HR business partner.</h6>
      </IconWithText>

      <IconWithText
        iconClassName="big-icon onboarding-cpa-download-icon-3 bg-secondary"
        wrapperClassName="mb-3"
      >
        <h6>
          Your next step: Schedule your AI-assisted Leadership Debrief to
          explore your results and begin creating your personalized development plan.
        </h6>
      </IconWithText>
    </>
  );
}
